import { ReactNode } from 'react';
import { Body } from './Body';

type PageProps = {
  children: ReactNode;
  showFooter?: boolean;
};

export const Page = ({ children, showFooter }: PageProps) => {
  return (
    <div className={`pt-safe pb-safe flex h-dvh min-h-dvh flex-col`}>
      <Body showFooter={showFooter}>{children}</Body>
    </div>
  );
};
